import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  background: transparent;
`;

export const BackButton = styled(Button)`
  background: ${(p) => p.theme.palette.common.white};
`;
